import React from 'react';
import FlyoutSwitch, {FORECASTING_FLYOUT_MODE} from '../common/FlyoutSwitch';

const FlyoutPricingAssumptions = () => {
	return <FlyoutSwitch startMode={FORECASTING_FLYOUT_MODE.PRICING_ASSUMPTION_LIST} />;
};

export default FlyoutPricingAssumptions;
